import { z } from 'zod';
import { TentTypeV1 } from '@camp67/model';

export const inquirySchema = z.object({
  name: z
    .string()
    .min(1, 'Name is required')
    .min(2, 'Name must be at least 2 characters'),
  email: z
    .string()
    .min(1, 'Email is required')
    .email('Please enter a valid email address'),
  phone: z
    .string()
    .min(1, 'Phone number is required')
    .min(6, 'Phone number is too short'),
  tents: z.record(z.nativeEnum(TentTypeV1), z.number().min(0).max(10)).default({}),
  checkIn: z.string().optional(),
  checkOut: z.string().optional(),
  guests: z.string().optional(),
  message: z.string().optional(),
});

export type InquiryFormValues = z.infer<typeof inquirySchema>;

export const tentOptions = [
  {
    value: TentTypeV1.TWIN_ROOM,
    labelKey: 'camp67-inquiry.twin-cottage' as const,
    capacity: 2,
  },
  {
    value: TentTypeV1.FAMILY_ROOM,
    labelKey: 'camp67-inquiry.family-cottage' as const,
    capacity: 4,
  },
  {
    value: TentTypeV1.PRIVATE_GROUP_COTTAGE,
    labelKey: 'camp67-inquiry.private-group' as const,
    capacity: 8,
  },
  {
    value: TentTypeV1.DORM_SINGLE,
    labelKey: 'camp67-inquiry.dorm-single' as const,
    capacity: 1,
  },
  {
    value: TentTypeV1.DORM_BUNK,
    labelKey: 'camp67-inquiry.dorm-bunk' as const,
    capacity: 1,
  },
];

export function calculateCapacity(tents: Partial<Record<TentTypeV1, number>>) {
  return Object.entries(tents).reduce((acc, [type, count]) => {
    const option = tentOptions.find((o) => o.value === type);
    return acc + (option?.capacity ?? 0) * (count ?? 0);
  }, 0);
}

export function calculateTotalRooms(tents: Partial<Record<TentTypeV1, number>>) {
  return Object.values(tents).reduce((a, b) => a + (b ?? 0), 0);
}
